@use '@design/design-tokens/typography/typography' as *;

.root {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
  padding: 0;
  margin: 0;
  font-size: 12px;
  max-width: fit-content;
}

/* Match the original `.legendItemRoot`: soft background + soft border,
 * a 4px radius, and a darker hover border (`--border-hover`) so the item
 * reads as a pill/button. */
.item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 2px;
  padding-right: 6px;
  border-radius: 4px;
  background: var(--background-soft);
  border: 1px solid var(--border-soft);
  color: var(--text-default);
  font-family: inherit;
  line-height: 1.1;
  white-space: nowrap;
  transition: border-color 120ms ease;
  width: fit-content;
}

.item:hover {
  border-color: var(--border-hover);
}

.item.hidden {
  opacity: 0.45;
}

.itemHeader {
  display: inline-flex;
  align-items: center;
  min-width: 0;
}

.fallbackLabel {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--chartv2-foreground, var(--text-default, #eee));
  padding: 2px 6px;
}

.itemBody {
  display: flex;
  align-items: center;
  margin-left: auto;
  position: relative;
  min-height: 20px;
}

/* Right-hand side of the legend row. Consumers render whatever they
 * want (price, change, live-market icons) via `series.legendStatus`; we
 * just provide the layout slot. */
.restingContent {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
}

.hoverActions {
  display: none;
  align-items: center;
  gap: 2px;
}

.item:hover .restingContent {
  display: none;
}

.item:hover .hoverActions {
  display: inline-flex;
}

.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  background: transparent;
  border: none;
  color: inherit;
  opacity: 0.75;
  cursor: pointer;
  padding: 0;
  border-radius: 4px;
}

.iconButton:hover {
  opacity: 1;
  background: var(--chartv2-chip-hover, rgba(255, 255, 255, 8%));
}

.moreRoot {
  position: relative;
  display: inline-flex;
}

.moreMenu {
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  min-width: 220px;
  z-index: 5;
  display: flex;
  flex-direction: column;
  padding: 0;
  background-color: var(--surface-default);
  border-radius: 4px;
  box-shadow: var(--elevation-moderate);
  outline: 1px solid var(--border-soft);
}

.moreItemWrapper {
  position: relative;
  margin: 8px 8px 0;
}

.moreItemWrapper:last-child {
  margin-bottom: 8px;
}

.moreItem {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px;
  width: 100%;
  background: transparent;
  border: 0;
  color: var(--chartv2-foreground, var(--text-default, #eee));
  font-family: inherit;
  @include typography-v2-body-sm;
  text-align: left;
  cursor: pointer;
  border-radius: 4px;
}

.moreItem:hover,
.moreItem.moreItemActive {
  background: var(--chartv2-chip-hover, rgba(255, 255, 255, 8%));
}

.moreItem.disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.moreItemIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.moreItemLabel {
  flex: 1 1 auto;
}

.moreItemChevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  color: var(--chartv2-axis-label, var(--text-soft, rgba(255, 255, 255, 60%)));
}

.subMenu {
  position: absolute;
  top: -4px;
  left: calc(100% + 4px);
  width: fit-content;
  z-index: 6;
  display: flex;
  flex-direction: column;
  padding: 0;
  background-color: var(--surface-default);
  border-radius: 4px;
  box-shadow: var(--elevation-moderate);
  outline: 1px solid var(--border-soft);
}

.colorDot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex-shrink: 0;
}

.empty {
  opacity: 0.5;
}
